import {
  impersonationLoading,
  impersonationLoaded,
  impersonationError,
  stopImpersonation,
} from "./adminStateActions";
import apiAdmin from "./adminApi";
import axios, { CancelToken } from "axios";

export function startImpersonation(email: string, cancelToken?: CancelToken) {
  return function (dispatch: any) {
    dispatch(impersonationLoading());
    apiAdmin
      .startImpersonation(email, cancelToken)
      .then(
        (id) => {
          dispatch(impersonationLoaded({ email: email, id: id }));
        },
        function (error: any) {
          if (!axios.isCancel(error)) {
            console.error(error);
            dispatch(impersonationError("Error starting impersonation"));
          }
        }
      )
      .catch((error: any) => {
        if (!axios.isCancel(error)) {
          console.error("Error in catch", error);
          dispatch(impersonationError("Error starting impersonation"));
        }
      });
  };
}

export function stopImpersonationAction(cancelToken?: CancelToken) {
  return function (dispatch: any) {
    dispatch(stopImpersonation());

    //   dispatch(impersonationLoading());
    //   apiAdmin
    //     .stopImpersonation(cancelToken)
    //     .then(
    //       () => {
    //         dispatch(stopImpersonation());
    //       },
    //       function (error: any) {
    //         if (!axios.isCancel(error)) {
    //           console.error(error);
    //           dispatch(impersonationError("Error stopping impersonation"));
    //         }
    //       }
    //     )
    //     .catch((error: any) => {
    //       if (!axios.isCancel(error)) {
    //         console.error("Error in catch", error);
    //         dispatch(impersonationError("Error stopping impersonation"));
    //       }
    //     });
  };
}

export function sendTestEmail(templateKey: string) {
  return apiAdmin.sendTestEmail(templateKey);
}

export function grantTrial(email: string, cancelToken?: CancelToken) {
  return apiAdmin.grantTrial(email, cancelToken);
}
